import { Component, EventEmitter, Input, Output } from '@angular/core'
import { BarAction, BarActionId, BarState } from 'src/app/domain/editor'

/** The one sticky action bar for editors. Put it in rt-page's footer slot: `<rt-editor-bar rtPageFooter …>`.
 *  Extra leading buttons (WOR Delete, Expense two-tap Delete) go in `<button rtBarStart>`. */
@Component({
  selector: 'rt-editor-bar',
  template: `
    <div class="rt-bar">
      <div class="rt-bar__start"><ng-content select="[rtBarStart]"></ng-content></div>
      <span class="rt-bar__note rt-bar__note--{{ state.note.tone }}">{{ state.note.text }}</span>
      <div class="rt-bar__actions">
        <button *ngFor="let a of state.actions; trackBy: byId" type="button" class="rt-btn rt-btn--bar rt-btn--{{ a.look }}"
                [class.is-unready]="!a.ready" [disabled]="a.look === 'done' || a.disabled" (click)="act.emit(a.id)">{{ a.label }}</button>
      </div>
    </div>`,
})
export class RtEditorBarComponent {
  @Input() state: BarState = { note: { text: '', tone: 'readonly' }, actions: [] }
  @Output() readonly act = new EventEmitter<BarActionId>()

  // Editors rebuild their bar state on every check. Without this the buttons are redrawn too, and a tap that blurs a
  // field (a check) loses its click to the replaced button, so it takes a second tap.
  byId(_: number, a: BarAction) {
    return a.id
  }
}
